import { useEffect, useState } from 'react';
import { useFetch } from './useFetch';
import { env } from '../config'


export const useNakdanRestoreKtivMale = (text) => {
    const [loading, setLoading] = useState(false);
    const { loading: fetchLoading, error, data, post, clean } = useFetch(`${env.REACT_APP_BASE_NAKDAN_API_URL()}/NakdanRestoreKtivMale`);

    useEffect(() => {
        if (text) {
            post({ Text: text })
        }
        else {
            clean();
        }
    }, [text, post, clean]);

    useEffect(() => {
        let isActive = true;

        if (!fetchLoading) {
            setTimeout(() => {
                if (isActive) {
                    setLoading(false);
                }
            }, 500);
        }
        else {
            setLoading(true);
        }

        return () => {
            isActive = false;
        };
    }, [fetchLoading]);

    return {
        loading,
        error,
        data,
    };
};